import { render, staticRenderFns } from "./PerseuInputImage.vue?vue&type=template&id=6ab1601d"
import script from "./PerseuInputImage.vue?vue&type=script&lang=js"
export * from "./PerseuInputImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports